import {
  Component,
  ViewChild,
  Input,
  OnInit,
  effect,
} from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { IonSelect } from "@ionic/angular";
import { IBeverage, IBeverageVM } from "../../../../models/beverage";
import { AlertController, ModalController } from "@ionic/angular";
import { IBeerStyle } from "../../../../models/beerstyle";
import { IKeg } from "../../../../models/keg";
import { BeerstyleService } from "../../../../services/dal/beerstyle.service";
import { UnitsHelper } from "../../../../services/units.helper";
import { Store } from '@ngrx/store';

import * as fromLocations from "app/state/location";
import * as fromKeg from "app/state/keg";
import * as fromUser from "app/state/user";
import * as fromBeerStyle from "app/state/beer-style";
import * as fromUnits from "app/state/units";
import * as fromSubscription from "app/state/subscription/reducer";
import * as fromBeverage from 'app/state/beverage/';
import * as fromTap from 'app/state/tap';
import * as fromExternalApiSettings from 'app/state/external-api-settings/reducer';

import { FormComponent } from './form/form.component';
import { HelpModalComponent } from "app/components/help-modal/help-modal.component";

@Component({
  selector: "app-beer-detail",
  templateUrl: "./beer-detail.page.html",
  styleUrls: ["./beer-detail.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule,
    FormComponent,
  ]
})
export class BeerDetailPage implements OnInit {
  @Input() isModal!: boolean;
  @Input() itemId!: string;
  @Input("useURI") useURI: Boolean = true;

  @ViewChild("searchSelectList") searchSelectListRef!: IonSelect;
  @ViewChild("addKegSelectList") addKegSelectListRef!: IonSelect;
  @ViewChild("addBottleSelectList") addBottleSelectListRef!: IonSelect;
  @ViewChild("addCanSelectList") addCanSelectListRef!: IonSelect;
  item!: IBeverageVM;

  searchPopoverOptions: any = {
    interface: "ion-alert",
    header: "Select search type",
  };


  barId$ = this.store.select(fromUser.selectBarId);
  uid$ = this.store.select(fromUser.selectUserId);
  kegs$ = this.store.select(fromKeg.getKegsWithUnitBeverageAndLocation);
  attachedKegs$ = this.store.select(fromTap.getKegsWithTapsFilteredByBeverageIdFromRouterParam)
  unitTypes$ = this.store.select(fromUnits.getUnits);
  locations$ = this.store.select(fromLocations.selectAllItems);
  isPremium$ = this.store.select(fromSubscription.getHasPremium);
  beerstyles$ = this.store.select(fromBeerStyle.getAllItems);
  beverage$ = this.store.select(fromKeg.getBeverageWithKegsFromRouteParams);
  externalApiSettings$ = this.store.select(fromExternalApiSettings.selectItem);

  constructor(
    private store: Store,
    public alertController: AlertController,
    private beerStyleService: BeerstyleService,
    public modalController: ModalController,
    public unitHelper: UnitsHelper,
  ) {

  }

  ngOnInit(): void {
    if (this.itemId) {
      this.beverage$ = this.store.select(fromKeg.getBeverageWithKegs(this.itemId));
    }
  }

  softUpdateBeverage(event: any) {
    this.store.dispatch(fromBeverage.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }

  removeKegFromBeverage(event: any) {
    const beverageId = event.beverageId;
    const kegId = event.kegId;
    this.store.dispatch(fromBeverage.removeKegFromBeverage({ beverageId, kegId }));

    const kegUpdate: Partial<IKeg> = {
      beverageId: null,
    }
    this.store.dispatch(fromKeg.softUpdate({ id: kegId, data: kegUpdate, uid: event.uid }));
  }

  softUpdateKeg(event: any) {
    this.store.dispatch(fromKeg.softUpdate({ id: event.id, data: event.data, uid: event.uid }));
  }

  deleteBeerstyle(id: string) {
    this.store.dispatch(fromBeerStyle.deleteItem({ id: id }));
  }

  addBeerstyle(event: any) {
    const barId = event.barId;
    const name = event.name;
    const id = this.beerStyleService.getNewId();
    const item: IBeerStyle = {
      barId: barId,
      name: name
    };
    this.store.dispatch(fromBeerStyle.addItem({ id: id, item: item }));
  }

  closeModal() {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  async confirmAlert(item: IBeverage) {
    const alert = await this.alertController.create({
      header: "Delete beer",
      message: `Are you sure you want to delete ${item.name}?`,
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: 'alert-button-cancel'
        },
        {
          text: "Delete",
          cssClass: 'alert-button-delete',
          handler: () => {

            this.delete(item);
          },
        },
      ],
    });

    await alert.present();
  }

  private delete(item: IBeverage) {
    if (item.id) {
      this.store.dispatch(fromBeverage.deleteItem({ id: item.id }));
    }
  }

  public async openHelpModal() {
    const modal = await this.modalController.create({
      component: HelpModalComponent,
      componentProps: {
        component: 'BeerDetailPage'
      }
    });
    return await modal.present();
  }

}
